import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  realm: process.env.REACT_APP_SSO_REALM!,
  url: process.env.REACT_APP_SSO_URL!,
  clientId: process.env.REACT_APP_SSO_CLIENT_ID!,
});


export default keycloak;
